<template>
  <div class="ui icon message" :class="isFooter ? 'footer-partner' : 'in-watchdog'">
    <i class="close icon" @click="$emit('dismiss')"></i>
    <div class="content">
      <a href="https://register.payoneer.com/en/solution/capital-advance/?p=sentrykit" target="_blank" style="width: min(35vmin, 350px); line-height: 0;">
        <img src="https://d9hhrg4mnvzow.cloudfront.net/register.payoneer.com/en/solution/capital-advance/5f9c1dd5-payoneer-capital-advance-logo-dark-sml_1000000000000000000028.png"
             style="width: 100%;"
             alt="banner"
        />
      </a>
      <span>Need cash to replenish stock? &nbsp;&nbsp;SentryKit users get&nbsp;<strong>10% fee rebate</strong>&nbsp;on their first Payoneer Capital Advance.</span>
      <a href="https://register.payoneer.com/en/solution/capital-advance/?p=sentrykit" target="_blank" class="mini ui icon button">
        {{isFooter ? 'Learn more' : ''}}<i class="arrow right icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnerBanner',
  props: ['isFooter']
}
</script>

<style scoped>
.ui.message.in-watchdog {
  position: sticky;
  left: 0;
  bottom: 2px;
  padding: 0.5em 1.5em;
  margin-top: 2px;
}

.ui.message.footer-partner {
  position: fixed;
  left: 0;
  bottom: 0;
  margin: 0;
  padding: 0.5em 5em;
  z-index: 2;
}
.ui.message.footer-partner .icon {
  left: 0.5em;
  right: auto;
}
.ui.icon.message.footer-partner > .content, .ui.message.in-watchdog > .content{
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 0.25em;
}
</style>



// WEBPACK FOOTER //
// PartnerBanner.vue?267ce3b9